var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Type, Expose, Transform } from 'class-transformer';
import moment from 'moment';
export class RestoreRequestModel {
    id;
    accountName;
    volume;
    volumeInBytes;
    status;
    createdBy;
    query;
    filters;
    restoreAccountId;
    archiveSettingsId;
    startTime;
    endTime;
    createdAt;
    finishedAt;
    expiresAt;
    phase;
    filesTotal;
    filesDone;
    indexingProgressPct;
    estimatedFinishAt;
}
__decorate([
    Expose({ toPlainOnly: true }),
    __metadata("design:type", Number)
], RestoreRequestModel.prototype, "archiveSettingsId", void 0);
__decorate([
    Type(() => Date),
    Transform(value => moment(value * 1000), { toClassOnly: true }),
    Transform(value => value.seconds(0).valueOf(), { toPlainOnly: true }),
    __metadata("design:type", Object)
], RestoreRequestModel.prototype, "startTime", void 0);
__decorate([
    Type(() => Date),
    Transform(value => moment(value * 1000), { toClassOnly: true }),
    Transform(value => value.seconds(0).valueOf(), { toPlainOnly: true }),
    __metadata("design:type", Object)
], RestoreRequestModel.prototype, "endTime", void 0);
__decorate([
    Type(() => Date),
    Transform(value => moment(value * 1000), { toClassOnly: true }),
    Transform(value => value?.valueOf(), { toPlainOnly: true }),
    __metadata("design:type", Object)
], RestoreRequestModel.prototype, "createdAt", void 0);
__decorate([
    Type(() => Date),
    Transform(value => moment(value * 1000), { toClassOnly: true }),
    Transform(value => value?.valueOf(), { toPlainOnly: true }),
    __metadata("design:type", Object)
], RestoreRequestModel.prototype, "finishedAt", void 0);
__decorate([
    Type(() => Date),
    Transform(value => moment(value * 1000), { toClassOnly: true }),
    Transform(value => value?.valueOf(), { toPlainOnly: true }),
    __metadata("design:type", Object)
], RestoreRequestModel.prototype, "expiresAt", void 0);
__decorate([
    Type(() => Date),
    Transform(value => (value ? moment(value * 1000) : null), { toClassOnly: true }),
    Transform(value => value?.valueOf(), { toPlainOnly: true }),
    __metadata("design:type", Object)
], RestoreRequestModel.prototype, "estimatedFinishAt", void 0);
export class EstimationCostRequestModel {
    query;
    startTime;
    endTime;
    constructor({ query, startTime, endTime }) {
        this.endTime = endTime;
        this.startTime = startTime;
        this.query = query;
    }
}
export class RestoreEstimationResponseModel {
    estimatedScanSizeInGB;
    costInUSD;
}
export class QueryValidationResponseModel {
    errorMsg;
    success;
}
//# sourceMappingURL=restore-request.js.map